import get from 'lodash/get';
import { selectParsedCustomAttributes } from 'store/CustomAttributes/selectors';
import defaultFields from 'store/ManageGeneral/fields';

// eslint-disable-next-line import/prefer-default-export
export const selectVulnsGeneralFields = (state) => {
  let fields = get(state, 'preferences.manage_table', defaultFields);
  const excludedFields = ['description', 'params', 'pname', 'references', 'request', 'resolution', 'response', 'policyviolations', 'data', 'evidence'];

  fields = Object.keys(defaultFields).reduce((filteredFields, field) => {
    if (!excludedFields.includes(field)) {
      const defaultField = defaultFields[field];
      const currentField = get(fields, field, defaultField);
      filteredFields[field] = { ...defaultField, ...currentField };
    }
    return filteredFields;
  }, {});

  const customFields = selectParsedCustomAttributes(state);

  return {
    ...customFields,
    ...fields
  };
};
